import { render, staticRenderFns } from "./ServiceJoinStep2Contentsogauc.vue?vue&type=template&id=c39b7a1c"
import script from "./ServiceJoinStep2Contentsogauc.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep2Contentsogauc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c39b7a1c')) {
      api.createRecord('c39b7a1c', component.options)
    } else {
      api.reload('c39b7a1c', component.options)
    }
    module.hot.accept("./ServiceJoinStep2Contentsogauc.vue?vue&type=template&id=c39b7a1c", function () {
      api.rerender('c39b7a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep2Contentsogauc.vue"
export default component.exports